import styled from 'styled-components'

import theme, { breakpoint } from 'style/theme'

export default styled.div`
  position: relative;
  z-index: 1;

  .header-container {
    display: flex;
    justify-content: center;
    margin-bottom: 24px;

    .text-header {
      .ant-typography {
        font-size: 36px;
      }
    }
  }

  .content {
    position: relative;

    .title {
      text-align: left;
    }

    .review-content {
      .desktop {
        a {
          color: ${theme.black};
        }

        .swiper-button-custom {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          z-index: 1;
          padding: 10px;
          cursor: pointer;
          width: 50px;
          height: 50px;
          border-radius: 100%;
          background: ${theme.moreLightGray};
          display: flex;
          align-items: center;
          justify-content: center;

          &.swiper-button-custom-prev {
            left: -74px;
            img {
              transform: rotate(180deg);
            }
          }
          &.swiper-button-custom-next {
            right: -74px;
          }
        }

        .swiper-slide {
          padding: 2px 0 15px 0;
          border-radius: 20px;
        }
      }

      .review-item {
        /* height: 370px; */
        padding: 20px 29px;
        border-radius: 20px;
        overflow: hidden;
        background: ${theme.white};
        box-shadow: 2px 5px 13px 0px rgb(0 0 0 / 10%);

        .image-container {
          margin-top: 15px;
          display: flex;
          flex-direction: row;
          gap: 12px;
          .image-review {
            flex: 1;
            aspect-ratio: 1 / 1;
            img {
              width: 100%;
              height: auto;
              border-radius: 20px;
              object-fit: cover;
              aspect-ratio: 1 / 1;
            }
          }
        }

        .info-block {
          .title {
            font-size: 26px;
          }

          .score-block {
            display: flex;
            flex-direction: row;
            align-items: center;
            align-content: center;
            gap: 11px;
            margin-bottom: 5px;

            .text-score {
              .ant-typography {
                font-size: 26px;
              }
            }

            .rate {
              display: flex;
              align-items: center;

              .ant-rate {
                font-size: 0;

                .ant-rate-star:not(:last-child) {
                  margin-right: 4px;
                }

                .anticon-star {
                  font-size: 20px;
                }
              }
            }
          }

          .detail {
            height: 65px;
            overflow: hidden;
            .ant-typography {
              color: ${theme.mediumGray};
              font-size: 16px;
            }
          }
        }
      }
    }

    .button-block {
      display: flex;
      align-items: center;
      justify-content: center;
      button {
        box-shadow: 0 0 20px 0 rgba(226, 64, 54, 0.2);
      }
    }
  }

  @media (max-width: ${breakpoint.lg}) {
    .content {
      .review-content {
        .desktop {
          .swiper-button-custom {
            &.swiper-button-custom-prev {
              left: -60px;
              img {
                transform: rotate(180deg);
              }
            }
            &.swiper-button-custom-next {
              right: -60px;
            }
          }
        }
      }
    }
    &.swiper-button-custom-prev {
      left: -34px;
    }
    &.swiper-button-custom-next {
      right: -74px;
    }
  }

  @media (max-width: ${breakpoint.md}) {
    .header-container {
      .text-header {
        .ant-typography {
          font-size: 20px;
        }
      }
    }

    .content {
      .review-content {
        .mobile {
          display: flex;
          flex-direction: column;
          gap: 24px;
        }

        .review-item {
          border-radius: 30px;
          padding: 20px 22px;

          .image-container {
            gap: 15px;
            .image-review {
              height: auto;
            }
          }

          .info-block {
            .title {
              font-size: 20px;
            }

            .score-block {
              gap: 14px;
              margin-bottom: 20px;

              .text-score {
                .ant-typography {
                  font-size: 20px;
                }
              }

              .rate {
                .ant-rate {
                  .ant-rate-star:not(:last-child) {
                    margin-right: 4px;
                  }

                  .anticon-star {
                    font-size: 16px;
                  }
                }
              }
            }

            .detail {
              .ant-typography {
                font-size: 16px;
              }
            }
          }
        }
      }
    }
  }
`
